module.exports = __webpack_public_path__ + "static/21-aerial-views-vi-638195d399e4d844cdd4c08ec051252e.jpeg";